<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Engineering Classification
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="type"
                :label="this.localForm.type"
                :items="equipmentTypeOptions"
                color="wplblue0"
                prepend-icon="grid_view"
                hint="equipment type"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="dis"
                :label="this.localForm.dis"
                :items="engineeringDiscipline"
                color="wplblue0"
                prepend-icon="engineering"
                hint="engineering discipline"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="cat"
                :label="this.localForm.cat"
                :items="this.selectDisciplineCategoryOptions(this.localForm.dis)"
                color="wplblue0"
                prepend-icon="time_to_leave"
                hint="technical category"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.code"
              :rules="ruleMustBeFilledANDLessThan50"
              prepend-icon="short_text"
              hint="engineering code"
              persistent-hint
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.reg"
              :rules="ruleMustBeFilledANDLessThan50"
              prepend-icon="reorder"
              hint="register"
              persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.cert"
              :rules="ruleMustBeFilledANDLessThan100"
              prepend-icon="security"
              hint="certificate requirements"
              persistent-hint
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.const"
              :rules="ruleMustBeFilledANDLessThan50"
              prepend-icon="construction"
              hint="construction requirements"
              persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.comm"
              :rules="ruleMustBeFilledANDLessThan100"
              prepend-icon="science"
              hint="commissoning requirements"
              persistent-hint
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Technical Specifications
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.spec"
              :rules="ruleMustBeFilledANDLessThan50"
              prepend-icon="square_foot"
              hint="rating or spec"
              persistent-hint
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-3 mr-2 mt-4">
            <v-flex xs12>
              <v-textarea
              :change="updateFormChar()"
              :color="ui.textColor"
              :background-color="ui.btnColor"
              v-model="localForm.des"
              :disabled="false"
              :outline="true"
              :rules="ruleMustBeNotUndefinedANDLessThan2000"
              hint="equipment technical specifications"
              auto-grow
              persistent-hint
              ></v-textarea>
            </v-flex>
          </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import selectAsset from "@/data/options/mixins/selectAsset.js";
// import selectMaint from "@/data/options/mixins/selectMaint.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import equipOptions from "@/data/options/mixins/equipOptions.js";
import selectClassification from "@/data/options/mixins/selectClassification.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        type: "",
        cat: "",
        des: "",
        dis: "",
        reg: "",
        cert: "",
        code: "",
        const: "",
        comm: "",
        spec: ""
      },
      orgForm: {
        type: "",
        cat: "",
        reg: "",
        cert: "",
        des: "",
        dis: "",
        code: "",
        spec: "",
        const: "",
        comm: ""
      },
      type: "",
      cat: "",
      dis: ""
    };
  },
  watch: {
    // whenever question changes, this function will run
    dis() {
      this.localForm.dis = this.dis;
      this.updateFormChar();
    },
    type() {
      this.localForm.type = this.type;
      this.updateFormChar();
    },
    cat() {
      this.localForm.cat = this.cat;
      this.updateFormChar();
    }
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.des = this.getDetail.char.des;
    this.localForm.code = this.getDetail.char.code;
    this.localForm.type = this.getDetail.char.type;
    this.localForm.cat = this.getDetail.char.cat;
    this.localForm.dis = this.getDetail.char.dis;
    this.localForm.spec = this.getDetail.char.spec;
    this.localForm.const = this.getDetail.char.const;
    this.localForm.comm = this.getDetail.char.comm;

    this.orgForm.des = this.getDetail.char.des;
    this.orgForm.type = this.getDetail.char.type;
    this.orgForm.cat = this.getDetail.char.cat;
    this.orgForm.dis = this.getDetail.char.dis;
    this.orgForm.code = this.getDetail.char.code;
    this.orgForm.spec = this.getDetail.char.spec;
    this.orgForm.const = this.getDetail.char.const;
    this.orgForm.comm = this.getDetail.char.comm;
  },
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    selectAsset,
    // selectMaint,
    techOptions,
    equipOptions,
    selectClassification
  ],
  // components: {
  //   RoleDevelopmentManageCard,
  //   RoleDevelopmentSummaryCard
  // },
  computed: {
    ...mapGetters(["getDetail", "getDetailChar", "getCurrentPage"]),
    userStatus() {
      let status = null;
      if (this.getDetail.basic.act === true) {
        status = "Active";
      } else {
        status = "Not Active";
      }
      return status;
    }
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.dis !== this.orgForm.dis &&
        this.localForm.dis !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.dis = this.localForm.dis;
        // basic
        char.dis = this.localForm.dis;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(2.31, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.code !== this.orgForm.code &&
        this.localForm.code !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.code = this.localForm.code;
        // basic
        char.code = this.localForm.code;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(2.31, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.reg !== this.orgForm.reg &&
        this.localForm.reg !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.reg = this.localForm.reg;
        // basic
        char.reg = this.localForm.reg;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(2.31, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.cert !== this.orgForm.cert &&
        this.localForm.cert !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.cert = this.localForm.cert;
        // basic
        char.cert = this.localForm.cert;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(2.31, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.type !== this.orgForm.type &&
        this.localForm.type !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.type = this.localForm.type;
        // basic
        char.type = this.localForm.type;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(2.31, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.cat !== this.orgForm.cat &&
        this.localForm.cat !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.cat = this.localForm.cat;
        // basic
        char.cat = this.localForm.cat;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(2.31, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.des !== this.orgForm.des &&
        this.localForm.des !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.des = this.localForm.des;
        // basic
        char.des = this.localForm.des;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.66, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.spec !== this.orgForm.spec &&
        this.localForm.spec !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.spec = this.localForm.spec;
        // basic
        char.spec = this.localForm.spec;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.66, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.const !== this.orgForm.const &&
        this.localForm.const !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.const = this.localForm.const;
        // basic
        char.const = this.localForm.const;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.66, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.comm !== this.orgForm.comm &&
        this.localForm.comm !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.comm = this.localForm.comm;
        // basic
        char.comm = this.localForm.comm;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.66, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
